import { JobGrade, JobRootSpecialtyV2, JobSpeciality, JobSubSpeciality, WorkType } from './jobs';

export interface IAlertsList {
  total: number;
  page: number;
  limit: number;
  data: IAlert[];
}

export interface IAlert {
  id: string;
  createdAt: string;
  updatedAt: string;
  userId: string;
  name: string;
  frequency: string;
  query: IQuery;
  // Client side only
  isDeleted?: boolean;
}

export interface IQuery {
  endDate?: string | null;
  location?: string;
  startDate?: string | null;
  grade?: JobGrade;
  speciality?: JobSpeciality;
  rootSpeciality?: JobRootSpecialtyV2;
  subspeciality?: JobSubSpeciality;
  workType?: WorkType;
  keywords?: string;
}

export enum JobAlertFrequency {
  OnceADay = 'Once a day',
  Immediately = 'As soon as a job matches',
}
